import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';

const Main = styled.main`
  padding-top: var(--nav-h);
  min-height: 60vh;
  outline: none;
`;

interface LayoutProps {
  children: React.ReactNode;
  navActive?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, navActive = true }) => (
  <>
    <a className="skip-link" href="#main">
      Skip to content
    </a>
    <Navbar suppressActive={!navActive} />
    <Main id="main" tabIndex={-1}>
      {children}
    </Main>
    <Footer />
  </>
);

export default Layout;
